// extracted by mini-css-extract-plugin
export default {"imageWrapper":"HH-z","twoColumnImage":"IH-z"};